import React, { useEffect, useState } from 'react';
import { Input, Select } from 'htlib-copy';

import customTypes from 'types';
import { entitiesToSelectItems } from 'utils/select';

import { isMd5, useUrlParam } from './utils';

import './Filters.scss';

const NO_FOR_ALL = { caption: 'No for all', value: 'no_for_all' };
export default function Filters({ entities }) {
  const { setUrlParam, getUrlParam, deleteUrlParam } = useUrlParam();

  const currentIndex = getUrlParam('index');
  const currentEntityId = getUrlParam('entity');
  const currentMd5 = getUrlParam('image_md5');

  const [md5Input, setMd5Input] = useState(currentMd5 || '');

  useEffect(() => {
    setMd5Input(currentMd5 || '');
  }, [currentMd5]);

  const currentEntity = entities.find(({ id }) => id === currentEntityId) || {};
  const { indexes: indexesOfEntity = [] } = currentEntity;

  return (
    <div className="Filters">
      <h3 className="sectionTitle">Filters</h3>
      <div className="Filters__selects">
        <Select
          withSearch
          placeholder="-- Entity --"
          items={[NO_FOR_ALL, ...entitiesToSelectItems(entities)]}
          onSelect={value => {
            if (value === 'no_for_all') {
              deleteUrlParam('entity');
              deleteUrlParam('tags');
              setUrlParam('tags', value);
            } else {
              deleteUrlParam('tags');
              deleteUrlParam('entity');
              setUrlParam('tags', 'yes');
              setUrlParam('entity', value);
            }
            deleteUrlParam('page');
          }}
          selectedValue={currentEntityId || 'no_for_all'}
        />
        <Select
          items={indexesOfEntity}
          onSelect={indexName => {
            setUrlParam('index', indexName);
          }}
          placeholder="-- Index --"
          selectedValue={currentIndex}
        />

        <Input
          value={md5Input}
          placeholder="image md5"
          onChange={({ target: { value } }) => {
            setMd5Input(value);
            if (value && !isMd5(value)) return;
            if (value) {
              setUrlParam('image_md5', value);
            } else {
              deleteUrlParam('image_md5');
            }
            deleteUrlParam('page');
          }}
          message={md5Input && !isMd5(md5Input) ? `${md5Input} isn't a valid md5.` : null}
          messageType="error"
        />
      </div>
    </div>
  );
}

Filters.propTypes = {
  entities: customTypes.misc.missionEntities.isRequired,
};
